import type { I18n } from '@funkey/locales';
import type { I18N_CONF } from '@funkey/locales/config';

export namespace Units {
    /** @param percentage - An integer representing a percentage up to 2 fraction digits accuracy. F.e 10000 => 100% */
    export function formatPercentage(
        percentage: number,
        locale: I18N_CONF.Locale = 'nl-BE',
    ): `${number}%` {
        const formatted: string = percentage.toLocaleString(locale, {
            style: 'percent',
            maximumFractionDigits: 2,
            trailingZeroDisplay: 'stripIfInteger',
        });

        return formatted as any;
    }

    /** @todo: should be `Dinero.toFormat()` later on when we import more api code in the web app */
    export function formatEUR(cents: number, locale: I18N_CONF.Locale = 'nl-BE'): `€ ${number}` {
        const formatted: string = (cents / 100).toLocaleString(locale, {
            currency: 'EUR',
            style: 'currency',
            maximumFractionDigits: 2,
            trailingZeroDisplay: 'stripIfInteger',
            currencySign: 'standard',
            currencyDisplay: 'symbol',
        });

        return formatted as any;
    }

    export function formatPriceRangeEUR(
        i18n: I18n,
        range: {
            /** Mininum price in EUR */
            minPrice?: number | null;
            /** Maximum price in EUR */
            maxPrice?: number | null;
        },
    ) {
        if (range.minPrice && range.maxPrice && range.minPrice === range.maxPrice) {
            return Units.formatEUR(range.minPrice * 100);
        }

        if (range.minPrice) {
            return i18n._('From {price}', {
                price: Units.formatEUR(range.minPrice * 100),
            });
        }

        return i18n._('price_on_demand');
    }

    export function formatNumberWithThousandSeparator(
        number: number,
        locale: I18N_CONF.Locale = 'nl-BE',
    ): string {
        return number.toLocaleString(locale);
    }
}
